import { render } from "./PlayersPage.vue?vue&type=template&id=9adf30e0&ts=true"
import script from "./PlayersPage.vue?vue&type=script&lang=ts"
export * from "./PlayersPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Admin/Players/PlayersPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9adf30e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9adf30e0', __exports__)) {
    api.reload('9adf30e0', __exports__)
  }
  
  module.hot.accept("./PlayersPage.vue?vue&type=template&id=9adf30e0&ts=true", () => {
    api.rerender('9adf30e0', render)
  })

}


export default __exports__